import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { CredentialsService } from './credentials.service';

import { ParticipantService } from '@shared/services/participant/participant.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';
import { ErrorInputs, ErrorService } from '@shared/services/error.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorMessage } from '@shared/http/http.service';

export const AuthGuard: CanActivateFn = async (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean | UrlTree> => {
  const credentialsService: CredentialsService = inject(CredentialsService);
  const participantService: ParticipantService = inject(ParticipantService);
  const router: Router = inject(Router);
  const errorService: ErrorService = inject(ErrorService);

  const errorMaintenanceInProgress: ErrorInputs | null = await errorService.getErrorIfMaintenanceIsInProgress();
  if (errorMaintenanceInProgress) {
    errorService.showError(errorMaintenanceInProgress);
    return true;
  }

  let errorMessage: string = '';
  if (participantService.isParticipantDataRetrieved()) {
    return true;
  } else if (credentialsService.isAuthenticated()) {
    try {
      await Promise.all([participantService.retrieveParticipant(), participantService.retrieveMenu()]);
      return true;
    } catch (error: any) {
      if (typeof error === 'string') {
        errorMessage = error;
      } else if (error instanceof HttpErrorResponse) {
        errorMessage = error.statusText;
      } else {
        errorMessage = ErrorMessage.unknownError;
      }
    }
  }

  const urlTree: UrlTree = router.parseUrl(getRoutePath(PlRoute.login));
  urlTree.queryParams = { redirect: state.url, errorMessage };
  return urlTree;
};
